import { useQuery } from '@tanstack/react-query';
import type { BrowseResponse } from '@thottbot/shared';
import { apiGet } from '../../api/client';

/** Zone names for filters and forms, from the seeded zone artifacts (first two pages cover vanilla). */
export function useZoneNames(): string[] {
  const q = useQuery({
    queryKey: ['zone-names'],
    staleTime: 10 * 60_000,
    queryFn: async () => {
      const first = await apiGet<BrowseResponse>('/api/browse/zone');
      const names = first.items.map((z) => z.name);
      if (first.total > first.pageSize) {
        const second = await apiGet<BrowseResponse>('/api/browse/zone?page=2');
        names.push(...second.items.map((z) => z.name));
      }
      return names.sort((a, b) => a.localeCompare(b));
    },
  });
  return q.data ?? [];
}
